import { useSafeAreaInsets } from "react-native-safe-area-context";
import { HEADER_HEIGHT } from "./HEADER_HEIGHT";

export const ISSUE_BOTTOM_SHEET_FIRST_SNAP_CONTENT_HEIGHT = 120;

export function useReportIssueBottomSheetMainScreenFirstSnapPoint() {
  const insets = useSafeAreaInsets();
  return (
    ISSUE_BOTTOM_SHEET_FIRST_SNAP_CONTENT_HEIGHT + insets.bottom + HEADER_HEIGHT
  );
}

export function useReportIssueBottomSheetMainScreenFirstSnapPointHeight() {
  return ISSUE_BOTTOM_SHEET_FIRST_SNAP_CONTENT_HEIGHT + HEADER_HEIGHT;
}
